import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        // Sélectionner tous les éléments avec la classe .js-single-car-item-toggler
        const togglerElements = document.querySelectorAll('.js-single-car-item-toggler');

        // Ajouter un gestionnaire d'événements à chaque élément
        togglerElements.forEach(toggler => {
            toggler.addEventListener('click', function() {
                const mobileGrid = document.querySelector('.js-single-car-mobile-grid-mobile');

                // Si l'élément cliqué possède déjà la classe .-is-active
                if (this.classList.contains('-is-active')) {
                    mobileGrid.classList.toggle('-is-expend');
                } else {
                    // Retirer la classe -is-active de tous les éléments avec la classe .js-single-car-item-toggler
                    document.querySelectorAll('.js-single-car-item-toggler.-is-active').forEach(function(element) {
                        element.classList.remove('-is-active');
                    });

                    // Basculer la classe -is-active sur l'élément cliqué
                    this.classList.toggle('-is-active');

                    // Ajouter la classe -is-expend sur l'élément .js-single-car-mobile-grid-mobile
                    mobileGrid.classList.add('-is-expend');

                    // Retirer la classe -is-active de tous les éléments avec la classe .js-single-car-item-mobile
                    document.querySelectorAll('.js-single-car-item-mobile.-is-active').forEach(function(element) {
                        element.classList.remove('-is-active');
                    });

                    // Utiliser l'attribut data-grid-toggle de l'élément cliqué pour cibler l'élément correspondant
                    const gridItem = this.getAttribute('data-grid-toggle');
                    if (gridItem) {
                        document.querySelector(`[data-grid-item="${gridItem}"]`).classList.toggle('-is-active');
                        document.querySelector(`.js-single-car-item-mobile[data-grid="${gridItem}"]`).classList.toggle('-is-active');
                    }
                }
            });
        });

        // Sélectionner l'élément avec la classe .js-single-car-item-closer
        const closerElement = document.querySelector('.js-single-car-item-closer');
        if (closerElement) {
            closerElement.addEventListener('click', function() {
                // Basculer la classe -is-expend sur l'élément le plus proche avec la classe .js-single-car-mobile-grid-mobile
                const closestMobileGrid = this.closest('.js-single-car-mobile-grid-mobile');
                if (closestMobileGrid) {
                    closestMobileGrid.classList.toggle('-is-expend');
                }
            });
        }
    }
}